import {Component, Input} from '@angular/core';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'invoices',
  template: `
    <mat-card>
      <p>Invoices</p>
      <span>Coming soon ...</span>
    </mat-card>`,
})

export class InvoicesComponent {
  orders: Array<any>;
  @Input() id: number;
  constructor(private userService: UserService) {}
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/invoices/invoices.component.ts